import { ChevronRight, Clock, Play } from 'lucide-react';
import { useNavigate } from 'react-router';

const SESSION_LINKS = [
  { label: '5–10 minute session', subtitle: 'Quick reset', yocasType: 'session', duration: '5-10' },
  { label: '15–30 minute session', subtitle: 'Balanced flow', yocasType: 'session', duration: '15-30' },
  { label: '60–75 minute session', subtitle: 'Deep practice', yocasType: 'session', duration: '60-75' },
];

/**
 * @param {{ onComplete?: () => void }} props
 */
export function YogiVideoLinks({ onComplete }) {
  const navigate = useNavigate();

  const handleClick = (link) => {
    navigate('/videos', { state: { yocasType: link.yocasType, duration: link.duration } });
    onComplete?.();
  };

  return (
    <div className="space-y-2">
      <p className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">
        <Play className="h-3.5 w-3.5" strokeWidth={2} />
        Choose a session
      </p>
      {SESSION_LINKS.map((link) => (
        <button
          key={link.duration}
          type="button"
          onClick={() => handleClick(link)}
          className="group flex w-full items-center gap-3 rounded-xl border border-brand/10 bg-gradient-to-r from-surface/80 to-white px-3 py-3 text-left transition-all hover:border-brand/20 hover:shadow-[var(--shadow-sm)] active:scale-[0.99] min-h-[44px]"
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
            <Play className="h-4 w-4 fill-current" strokeWidth={0} />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-sm font-medium text-brand">{link.label}</span>
            <span className="flex items-center gap-1 text-xs text-text-secondary">
              <Clock className="h-3 w-3" strokeWidth={2} />
              {link.subtitle}
            </span>
          </span>
          <ChevronRight className="h-4 w-4 shrink-0 text-text-secondary opacity-0 transition-all group-hover:translate-x-0.5 group-hover:opacity-100" strokeWidth={2} />
        </button>
      ))}
    </div>
  );
}
